import PermissionEnum from '@/enums/permission.enum'
import { collect } from 'collect.js'
import { defineStore } from 'pinia'
import { toRaw } from 'vue'
import Level from '@/enums/level.enum'
import PeopleService from '@/services/people.service'

const useAclStore = defineStore('acl', {
  persist: true,
  state: () => ({
    userPermissions: [] as any,
    isSuperAdmin: false
  }),
  actions: {
    clearUserPermissions() {
      this.userPermissions = []
    },
    setUserPermissions(userPermissions: []) {
      this.userPermissions = userPermissions
    },
    setIsSuperAdmin(condition: boolean) {
      this.isSuperAdmin = condition
    },
    addUserPermission(userPermission: any) {
      this.userPermissions.push(userPermission)
    },
    userIsAbleTo(permissionName: string, school_id?: string, course_id?: string) {
      if (this.isSuperAdmin) {
        return true
      }

      const permissions = findUserPermission(this.userPermissions, permissionName)
      return verifyPermissionsIsAble(permissions, school_id, course_id)
    },
    userHasAnyPerrmissionWith(permissionName: string) {
      if (this.isSuperAdmin) {
        return true
      }

      const permissions = findUserPermission(this.userPermissions, permissionName)
      return permissions.length > 0
    }
  },
  getters: {
    getUserPermissions(): any {
      return this.userPermissions
    },
    getUserPermissionsByName: (state) => (name: string) => {
      return findUserPermission(state.userPermissions, name)
    }
  }
})

const verifyPermissionsIsAble = async (
  permissions: any,
  school_id?: string,
  course_id?: string
) => {
  const peopleService = new PeopleService()
  const maxLevel = await peopleService.getUserMaxLevel()

  const permissionsTypes = getPermissionTypeToFilter(school_id, course_id)

  const filteredPermissions = collect(permissions).whereIn('type', permissionsTypes).all()

  if (Number(maxLevel) >= Number(Level.TECHNICAL)) {
    return true
  }

  if (collect(filteredPermissions).contains('type', PermissionEnum.ORGANIZATION)) {
    return true
  }

  if (course_id && collect(filteredPermissions).contains('course_id', course_id)) {
    return true
  }

  if (school_id && collect(filteredPermissions).contains('school_id', school_id)) {
    return true
  }

  return false
}

const getPermissionTypeToFilter = (school_id?: string, course_id?: string) => {
  return [
    PermissionEnum.ORGANIZATION,
    ...(school_id ? [PermissionEnum.SCHOOL] : []),
    ...(course_id ? [PermissionEnum.COURSE] : [])
  ]
}

const findUserPermission = (userPermissions: any, name: string) => {
  const permissions = userPermissions
  return collect(permissions)
    .map((userPermission: any) => {
      const permission = filterAclsByName(userPermission.acls, name)
      if (permission) {
        return {
          school_id: userPermission.school_id,
          course_id: userPermission.course_id,
          ...toRaw(permission)
        }
      } else {
        return null
      }
    })
    .whereNotNull()
    .toArray()
}

const filterAclsByName = (acls: any, name: string) => {
  return collect(acls).where('name', '===', name).first() ?? null
}

export default useAclStore
